import script from "./SizeSetList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SizeSetList.vue?vue&type=script&setup=true&lang=ts"

import "./SizeSetList.vue?vue&type=style&index=0&id=eb63d618&lang=css"

const __exports__ = script;

export default __exports__